import { render, staticRenderFns } from "./add-account.vue?vue&type=template&id=17fd64e0&scoped=true"
import script from "./add-account.vue?vue&type=script&lang=js"
export * from "./add-account.vue?vue&type=script&lang=js"
import style0 from "./add-account.vue?vue&type=style&index=0&id=17fd64e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fd64e0",
  null
  
)

export default component.exports